import { apirequest } from "../../helpers/api-client";
import { newApi } from "../restdux/index";

export const surveyVoteManager = newApi("surveyVote", "/api/survey-vote/");
export const reducer = surveyVoteManager.reducer;

export function fetchSurveyVotes(surveyId) {
  return surveyVoteManager.actions.list({ survey: surveyId });
}

export function castSurveyVote(data) {
  return () => apirequest("post", "/api/survey-vote/", data);
}

export function updateSurveyVote(data) {
  return surveyVoteManager.actions.update(data);
}

export function fetchMyVote(surveyId) {
  return () =>
    apirequest("get", `/api/survey-vote/my-vote/?survey=${surveyId}`);
}
